import { Typography } from '@design-system/components/typography/typography';
import { Community } from '../model/community.types';

type RowProps = {
  label: string;
  count: number;
  bold?: boolean;
};

const CountBadge = ({ count }: { count: number }) => (
  <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#F0F0F0] px-1.5">
    <Typography
      as="span"
      variant="body"
      className="text-[10px] font-medium leading-3 text-black"
    >
      {count}
    </Typography>
  </span>
);

const Row = ({ label, count, bold }: RowProps) => (
  <div className="flex items-center justify-between">
    <Typography
      as="span"
      variant="body"
      size={bold ? 'large' : 'medium'}
      className={bold ? 'font-bold text-black' : 'text-black'}
    >
      {label}
    </Typography>
    <CountBadge count={count} />
  </div>
);

type Props = {
  community: Community;
};

export const CommunityModerationSummary = ({ community }: Props) => (
  <div className="order-first flex w-full flex-col gap-3 rounded-[10px] border border-[#EEEEEE] bg-white p-5 lg:sticky lg:top-4 lg:order-none lg:w-[360px] lg:self-start">
    <div className="flex flex-col gap-1">
      <Row
        label="Moderation"
        count={community.reportedPostsCount + community.blockedUsersCount}
        bold
      />
      <Typography
        as="span"
        variant="body"
        size="small"
        className="text-[#9E9E9E]"
      >
        What happened in this channel
      </Typography>
    </div>
    <div className="flex flex-col gap-3">
      <Row label="Reported post" count={community.reportedPostsCount} />
      <Row label="Blocked users" count={community.blockedUsersCount} />
    </div>
  </div>
);
